import React, { useState, useEffect, useRef } from "react";
import Api from "../../../../services/ServiceApi";
import axios from "axios";
import { Collapse, Image } from "antd";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { setProblemDetailList } from "../../../../actions/fixProblemAction";
import { setFixProblemPic } from "../../../../actions/fixProblemPicAction";
import ApproveProcessLog from "../../../approve_process/approve_process_log";
const { Panel } = Collapse;
export default function Fixed_Problem_detail({
  CompanyId,
  OperatorId,
  ProjectId,
  headerdata,
  jobData,
  rereder,
}) {
  const dispatch = useDispatch();
  const { fixProblemDetailList, fixProblemPic } = useSelector((state) => ({
    fixProblemDetailList: state.fixProblemlist.fixProblemDetailList,
    fixProblemPic: state.fixProblemPic.fixProblemPic,
  }));
  const result_oper_job_pic = fixProblemPic;
  const [callApiSuccess, setcallApiSuccess] = useState(false);
  const [acceptanceApproveId, setacceptanceApproveId] = useState(null);
  const unmounted = useRef(false);
  useEffect(() => {
    setcallApiSuccess(false);
    axios
      .all([
        Api.post("job_detail/get_jobfixproblem_list", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          job_id: headerdata.job_id,
        }),
      ])
      .then(([resFixproblemList]) => {
        const { result: resultFixProblemList, data: dataFixProblemList } =
          resFixproblemList.data;

        if (resultFixProblemList.code === "P") {
          dispatch(
            setProblemDetailList(dataFixProblemList?.job_fixproblem_List)
          );
          dispatch(setFixProblemPic(dataFixProblemList?.result_oper_pic));
          Api.post("job_detail/get_oper_job_fixproblem_acceptance_list", {
            company_id: CompanyId,
            operator_id: OperatorId,
            project_id: ProjectId,
            job_id: headerdata.job_id,
            job_FixProblem_id:
              dataFixProblemList?.job_fixproblem_List[0]?.job_FixProblem_id,
          })
            .then((res) => {
              const { result, data } = res.data;
              if (result.code === "P") {
                setacceptanceApproveId(data[0]?.approve_id);
                setcallApiSuccess(true);
              } else {
                setcallApiSuccess(true);
              }
            })
            .catch(() => setcallApiSuccess(true));
        }
      });
    return () => {
      unmounted.current = true;
    };
  }, [headerdata.job_id, rereder]);
  return (
    <>
      {callApiSuccess ? (
        <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
          <Panel
            header={
              <>
                <h4>{"รายละเอียดสาเหตุ"}</h4>
              </>
            }
            key="1"
          >
            <div className="d-flex align-content-md-start flex-wrap w-100">
              {fixProblemDetailList?.length > 0 ? (
                fixProblemDetailList.map((data, index) => (
                  <>
                    <div
                      className="col col-12"
                      key={`fix_problem_detail_list_index${index}`}
                    >
                      <div className="row">
                        <span className="col-12 col-sm-4 content-label">
                          SLA Name
                        </span>
                        <span className="col-12 col-sm-8 content-text">
                          {data.slA_Name}
                        </span>
                      </div>
                      <div className="row">
                        <span className="col-12 col-sm-4 content-label">
                          Maintenancec Type
                        </span>
                        <span className="col-12 col-sm-8 content-text">
                          {data.maintain_name}
                        </span>
                      </div>
                      <div className="row">
                        <span className="col-12 col-sm-4 content-label">
                          Owner Network
                        </span>
                        <span className="col-12 col-sm-8 content-text">
                          {data.owner_network_name}
                        </span>
                      </div>
                      <div className="row">
                        <span className="col-12 col-sm-4 content-label">
                        Resolution Tier1
                        </span>
                        <span className="col-12 col-sm-8 content-text">
                          {data.cause_name}
                        </span>
                      </div>
                      <div className="row">
                        <span className="col-12 col-sm-4 content-label">
                        Resolution Tier2
                        </span>
                        <span className="col-12 col-sm-8 content-text">
                          {data.subCause_Desc2}
                          <br />
                          <span className="text-muted">
                            <strong>คำอธิบาย : </strong>
                            {data.subCause_Detail}
                          </span>
                        </span>
                      </div>
                      <div className="row">
                        <span className="col-12 col-sm-4 content-label">
                        Resolution Tier3
                        </span>
                        <span className="col-12 col-sm-8 content-text">
                          {data.tier3_name || "-"}
                        </span>
                      </div>
                      <div className="row">
                        <span className="col-12 col-sm-4 content-label">
                          Action
                        </span>
                        <span className="col-12 col-sm-8 content-text">
                          {data.cause_Probdetail_Fix_Name}
                          <br />
                          <span className="text-muted">
                            <strong>คำอธิบาย : </strong>
                            {data.cause_Probdetail_Fix_Desc}
                          </span>
                        </span>
                      </div>
                      <div className="row">
                        <span className="col-12 col-sm-4 content-label">
                          Problem Detail
                        </span>
                        <span className="col-12 col-sm-8 content-text">
                          {data.fixProblem_detail}
                        </span>
                      </div>
                      <div className="row">
                        <span className="col-12 col-sm-4 content-label">
                          รายละเอียดการแก้ไข
                        </span>
                        <span className="col-12 col-sm-8 content-text">
                          {data.fixProblem_Result}
                        </span>
                      </div>
                      <div className="row">
                        <span className="col-12 col-sm-4 content-label">
                          สาเหตุล่าช้า
                        </span>
                        <span className="col-12 col-sm-8 content-text">
                          {data.exclusion_detail}
                        </span>
                      </div>
                      <div className="row">
                        <span className="col-12 col-sm-4 content-label">
                          Photo
                        </span>
                        <span className="col-12 col-sm-8 content-text">
                          <div className="mr-4" style={{ cursor: "pointer" }}>
                            <Image.PreviewGroup>
                              {result_oper_job_pic
                                .filter(
                                  (s) =>
                                    s.reference_id === data.job_FixProblem_id &&
                                    s.pic_type === "F"
                                )
                                .map((m, i) => (
                                  <Image
                                    key={`operjob_pic_problem_${i}`}
                                    width={150}
                                    height={80}
                                    src={Api.checkPath(
                                      m.pic_url_path,
                                      m.pic_upload_name
                                    )}
                                  ></Image>
                                ))}
                            </Image.PreviewGroup>
                          </div>
                        </span>
                      </div>
                    </div>
                    <div className="col col-12 mt-2">
                      {acceptanceApproveId ? (
                        <div className="row">
                          <ApproveProcessLog
                            header="UIH ตรวจรับงาน"
                            sendData={{ approve_id: acceptanceApproveId }}
                          ></ApproveProcessLog>
                        </div>
                      ) : null}
                      {data?.approve_id ? (
                        <div className="row">
                          <ApproveProcessLog
                            header="Sub ตรวจรับงาน"
                            sendData={{ approve_id: data?.approve_id }}
                          ></ApproveProcessLog>
                        </div>
                      ) : null}
                    </div>
                  </>
                ))
              ) : (
                // <Skeleton height={400}></Skeleton>
                <div className="row">
                  <span className="col-12 content-text">
                    ไม่พบข้อมูลรายละเอียดสาเหตุ
                  </span>
                </div>
              )}
            </div>
          </Panel>
        </Collapse>
      ) : (
        <Skeleton height={400}></Skeleton>
      )}
    </>
  );
}
